<template>
  <div>
    <div v-if="softstart">
      <h4>Details for {{softstart.title}}</h4>
      <b-form>
        <b-form-group v-for="(field, i) in fields" :key="'field-'+i">
          <label class="field-label" for="field">{{field[1]}}</label>
          <div class="field-value">{{softstart[field[0]] || '---'}}</div>
          <hr />
        </b-form-group>
        <BFR :node="softstart.node" />
      </b-form>
    </div>
  </div>
</template>

<script>
import BFR from "./BFR.vue";

export default {
  name: "softstart",
  components: {
    BFR
  },
  props: {
    softstart: {}
  },
  data: () => ({
    loading: false,
    errors: [],
    filter: "",
    fields: [
      ["title", "Title"],
      ["manufacturer", "Manufacturer"],
      ["type", "Type"],
      ["modelNo", "Model Number"],
      ["kwRating", "KW Rating"],
      ["hpRating", "HP Rating"],
      ["voltageRating", "Voltage Rating"],
      ["currentRange", "Current Range (A)"],
      ["enclosureType", "Enclosure Type"],
      ["catNo", "Cat NO."],
    ]
  }),
  methods: {}
};
</script>

<style lang="scss" scoped>
</style>
